export interface I18NResource {
  ok: string;
  yes: string;
  no: string;
  cancel: string;
}
